<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{ 'canteen.information.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        {{ 'core.done' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-accordion-group #accordionGroup>
    <ion-accordion value="first" [disabled]="loadingOpenings || (!openings?.groups && !openings?.companyHolidays)">
      <ion-item slot="header" color="light">
        <ion-label class="flex flex-column gap-2">
          <span [class.font-bold]="!loadingOpenings && !openings?.groups && !openings?.companyHolidays">
            {{ 'canteen.openingHours' | translate }}
          </span>
          @if (!loadingOpenings && !openings?.groups && !openings?.companyHolidays) {
            <ion-text>
              {{ 'canteen.information.noOpeningHours' | translate }}
            </ion-text>
          }
        </ion-label>
      </ion-item>
        <div slot="content" class="ion-padding">
          @if (openings?.groups?.length) {
            @for (opening of openings.groups; track opening) {
              @if (opening?.title !== 'Öffnungszeit' && opening?.title !== 'Öffnungszeiten') {
                <ion-item lines="none">
                  <ion-label>
                    <h2><strong>{{ opening.title }}</strong></h2>
                  </ion-label>
                </ion-item>
              }
              @for (period of opening.periods; track period; let last = $last) {
                <ion-item [lines]="last && !(period.afternoonStartTime && period.afternoonEndTime) ? 'inset' : 'none'">
                  <ion-label>{{ period.days | numberToWeeksdays }}</ion-label>
                  <ion-text>
                    {{ canteenService.getDateFromTime(period.morningStartTime) | date: 'HH:mm' }} -
                    {{ canteenService.getDateFromTime(period.morningEndTime) | date: 'HH:mm' }}
                  </ion-text>
                </ion-item>
                @if (period.afternoonStartTime && period.afternoonEndTime) {
                  <ion-item [lines]="last ? 'inset' : 'none'">
                    <ion-label></ion-label>
                    <ion-text>
                      {{ canteenService.getDateFromTime(period.afternoonStartTime) | date: 'HH:mm' }} -
                      {{ canteenService.getDateFromTime(period.afternoonEndTime) | date: 'HH:mm' }}
                    </ion-text>
                  </ion-item>
                }
              }
            }
          }
          @if (openings?.companyHolidays?.length) {
            <ion-item lines="none">
              <ion-label><h2><strong>{{ 'canteen.holidays' | translate }}</strong></h2></ion-label>
            </ion-item>
            @for (holiday of openings.companyHolidays; track holiday; let first = $first) {
              @if (first || !isAfterLimit(holiday) || showAllCompanyHolidays) {
                <ion-item lines="none">
                  {{ holiday.start * 1000 | date: 'dd.MM.y' }}
                  @if (holiday.start !== holiday.end) {
                    - {{ holiday.end * 1000 | date: 'dd.MM.y' }}
                  }
                </ion-item>
              }
            }
            @if (showMoreButton()) {
              <ion-button fill="clear" size="small" color="secondary" style="float: right;" (click)="showAllCompanyHolidays = !showAllCompanyHolidays">
                {{ (showAllCompanyHolidays ? 'core.show.less' : 'core.show.more') | translate }}
              </ion-button>
            }
          }
        </div>
      </ion-accordion>
        <ion-accordion value="second" [disabled]="loadingTypes || !types">
          <ion-item slot="header" color="light">
            <ion-label class="flex flex-column gap-2">
              <span [class.font-bold]="!loadingTypes && !types">
                {{ 'canteen.information.types' | translate }}
              </span>
              @if (!loadingTypes && !types) {
                <ion-text>
                  {{ 'canteen.information.noTypes' | translate }}
                </ion-text>
              }
            </ion-label>
          </ion-item>
          <div slot="content" class="ion-padding">
          @if (types?.length) {
          <ion-list>
            @for (type of types; track type.id) {
              <ion-item>
                <ion-grid>
                  <ion-row>
                    <ion-col size="2"><img width="50px" height="20px" [src]="canteenService.getPictogram(type.id)"
                                           role="img" [alt]="type.id" /></ion-col>
                    <ion-col>{{ canteenService.getLocalizedString(type.name) }}</ion-col>
                  </ion-row>
                </ion-grid>
              </ion-item>
            }
          </ion-list>
        }
        </div>
      </ion-accordion>

      <ion-accordion value="third" [disabled]="loadingAdditives || !additives">
        <ion-item slot="header" color="light">
          <ion-label class="flex flex-column gap-2">
            <span [class.font-bold]="!loadingAdditives && !additives">
              {{ 'canteen.information.additives' | translate }}
            </span>
            @if (!loadingAdditives && !additives) {
              <ion-text>
                {{ 'canteen.information.noAdditives' | translate }}
              </ion-text>
            }
          </ion-label>
        </ion-item>
        <div slot="content" class="ion-padding">
          @if (additives?.length) {
            <ion-list>
              @for (additive of additives; track additive.id) {
                <ion-item>
                  <ion-grid>
                    <ion-row>
                      <ion-col size="2" class="ion-no-padding"><strong>{{ additive.id }}</strong></ion-col>
                      <ion-col
                        class="ion-no-padding ion-padding-horizontal">{{ canteenService.getLocalizedString(additive.name) }}
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-item>
              }
            </ion-list>
          }
        </div>
      </ion-accordion>
  </ion-accordion-group>
</ion-content>
